// ===== VIDEO TESTIMONIAL SECTION JAVASCRIPT =====

document.addEventListener('DOMContentLoaded', function() {
  initVideoTestimonialSlider();
  initVideoPlayControls();
});

// Initialize Swiper Slider
function initVideoTestimonialSlider() {
  const swiperContainers = document.querySelectorAll('.product_video_testimonials_unique_swiper');

  swiperContainers.forEach(container => {
    const totalSlides = container.querySelectorAll('.swiper-slide').length;
    const isDesktop = window.innerWidth >= 1200;
    const shouldDisableLoop = isDesktop && totalSlides <= 4;

    const swiper = new Swiper(container, {
      // Slider settings
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: !shouldDisableLoop,
      loop: !shouldDisableLoop,
      autoplay: false,
      initialSlide: 0, // FIXED: Always start from first slide

      // Responsive breakpoints - FIXED for mobile
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 15,
          centeredSlides: false, // FIXED: Changed from true to false
          initialSlide: 0, // FIXED: Ensure first slide starts
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 20,
          centeredSlides: false, // FIXED: Changed from true to false
          initialSlide: 0, // FIXED: Ensure first slide starts
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 25,
          centeredSlides: true,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 30,
          centeredSlides: true,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
          centeredSlides: false,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
          centeredSlides: false,
        }
      },

      // Navigation
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },

      // Pagination
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 5,
      },

      // Effects
      effect: 'slide',
      speed: 600,

      // Events
      on: {
        init: function() {
          // Add loaded class for animations
          container.classList.add('swiper-loaded');

          // Pause all videos initially
          pauseAllVideos(container);
          
          // FIXED: Ensure we're on the first slide after init
          this.slideTo(0, 0);
        },
        slideChange: function() {
          // Pause all videos when slide changes
          pauseAllVideos(container);
        },
        slideChangeTransitionEnd: function() {
          // Ensure smooth transition end
          container.classList.add('transition-complete');
        }
      }
    });

    // Store swiper instance for later use
    container.swiperInstance = swiper;

    // Handle touch/mouse interactions
    let isDragging = false;

    container.addEventListener('mousedown', () => isDragging = false);
    container.addEventListener('mousemove', () => isDragging = true);
    container.addEventListener('mouseup', (e) => {
      if (!isDragging) {
        handleSlideClick(e);
      }
    });

    container.addEventListener('touchstart', () => isDragging = false);
    container.addEventListener('touchmove', () => isDragging = true);
    container.addEventListener('touchend', (e) => {
      if (!isDragging) {
        handleSlideClick(e);
      }
    });
  });
}

// Initialize Video Play Controls
function initVideoPlayControls() {
  const videoContainers = document.querySelectorAll('.mp4_play_video_new');

  videoContainers.forEach(container => {
    const video = container.querySelector('video');
    const playButton = container.querySelector('.play_video_new');
    const muteButton = container.querySelector('.video_mute_button_new');

    if (video && playButton) {
      // Play button click handler
      playButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleVideoPlay(container, video);
      });

      // Video click handler (for play/pause)
      video.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleVideoPlay(container, video);
      });

      // Mute button click handler
      if (muteButton) {
        muteButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          toggleVideoMute(video, muteButton);
        });
      }

      // Video events
      video.addEventListener('play', function() {
        container.classList.add('playing');
        playButton.style.opacity = '0';
      });

      video.addEventListener('pause', function() {
        container.classList.remove('playing');
        playButton.style.opacity = '1';
      });

      video.addEventListener('ended', function() {
        container.classList.remove('playing');
        playButton.style.opacity = '1';
        video.currentTime = 0;
      });

      // Set video properties
      video.muted = false; // Allow sound by default
      video.loop = true;
      video.controls = false; // Remove default controls

      // Update mute button icon
      updateMuteButtonIcon(video, muteButton);
    }
  });
}

// Toggle Video Play/Pause
function toggleVideoPlay(container, video) {
  if (video.paused) {
    // Pause all other videos first
    pauseAllVideos();

    // Play this video
    video.play().then(() => {
      container.classList.add('playing');
    }).catch(error => {
      console.log('Video play failed:', error);
      // If play fails due to user interaction policy, try muted
      video.muted = true;
      video.play().then(() => {
        container.classList.add('playing');
      }).catch(e => console.log('Muted video play failed:', e));
    });
  } else {
    video.pause();
    container.classList.remove('playing');
  }
}

// Toggle Video Mute/Unmute
function toggleVideoMute(video, muteButton) {
  video.muted = !video.muted;
  updateMuteButtonIcon(video, muteButton);
}

// Update Mute Button Icon
function updateMuteButtonIcon(video, muteButton) {
  if (!muteButton) return;

  const isMuted = video.muted;
  muteButton.innerHTML = isMuted ?
    // Muted icon
    `<svg width="20" height="20" viewBox="0 0 24 24" fill="white">
      <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
    </svg>` :
    // Unmuted icon
    `<svg width="20" height="20" viewBox="0 0 24 24" fill="white">
      <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
    </svg>`;
}

// Pause All Videos
function pauseAllVideos(exceptContainer = null) {
  const allVideoContainers = document.querySelectorAll('.mp4_play_video_new');

  allVideoContainers.forEach(container => {
    if (exceptContainer && container.closest('.swiper') === exceptContainer) {
      return; // Skip videos in the same slider
    }

    const video = container.querySelector('video');
    if (video && !video.paused) {
      video.pause();
      container.classList.remove('playing');
    }
  });
}

// Handle Slide Click
function handleSlideClick(e) {
  const clickedSlide = e.target.closest('.swiper-slide');
  const swiperContainer = e.target.closest('.swiper');

  if (clickedSlide && swiperContainer && swiperContainer.swiperInstance) {
    const slideIndex = Array.from(clickedSlide.parentNode.children).indexOf(clickedSlide);
    const swiper = swiperContainer.swiperInstance;

    // If clicked slide is not active, go to it
    if (!clickedSlide.classList.contains('swiper-slide-active')) {
      swiper.slideToLoop(slideIndex);
    }
  }
}

// Intersection Observer for Performance
function initIntersectionObserver() {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '50px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const container = entry.target;
        if (!container.classList.contains('observer-loaded')) {
          container.classList.add('observer-loaded');

          // Initialize slider if not already done
          if (!container.swiperInstance) {
            initVideoTestimonialSlider();
          }
        }
      } else {
        // Pause videos when section is out of view
        pauseAllVideos(entry.target);
      }
    });
  }, observerOptions);

  // Observe all video testimonial sections
  const sections = document.querySelectorAll('.product_video_testimonials_main_new');
  sections.forEach(section => observer.observe(section));
}

// Initialize intersection observer when page loads
document.addEventListener('DOMContentLoaded', function() {
  if ('IntersectionObserver' in window) {
    initIntersectionObserver();
  }
});

// Handle window resize
let resizeTimeout;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function() {
    const swipers = document.querySelectorAll('.product_video_testimonials_unique_swiper');
    swipers.forEach(container => {
      if (container.swiperInstance) {
        container.swiperInstance.update();
        // FIXED: Reset to first slide on resize for mobile
        if (window.innerWidth < 640) {
          container.swiperInstance.slideTo(0, 0);
        }
      }
    });
  }, 250);
});

// Handle page visibility change
document.addEventListener('visibilitychange', function() {
  if (document.hidden) {
    pauseAllVideos();
  }
});

// Utility function to check if device supports touch
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

// Add touch class to body if touch device
if (isTouchDevice()) {
  document.body.classList.add('touch-device');
} else {
  document.body.classList.add('no-touch');
}

// Preload videos for better performance
function preloadVideos() {
  const videos = document.querySelectorAll('.product_video_testimonials_unique_swiper video');

  videos.forEach(video => {
    // Set preload attribute
    video.preload = 'metadata';

    // Ensure proper mobile playback
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  });
}

// Initialize preloading
document.addEventListener('DOMContentLoaded', preloadVideos);

// Error handling for videos
document.addEventListener('DOMContentLoaded', function() {
  const videos = document.querySelectorAll('.product_video_testimonials_unique_swiper video');

  videos.forEach(video => {
    video.addEventListener('error', function() {
      console.warn('Video failed to load:', video.src);
      const container = video.closest('.mp4_play_video_new');
      if (container) {
        container.style.display = 'none'; // Hide broken videos
      }
    });
  });
});